import React from "react";
import DomesticHelpList from "./domesticHelp";
import { withBottombar } from "../../HOCs";
class DomesticHelpParent extends React.Component {
  render() {
    return <DomesticHelpList {...this?.props} />;
  }
}

const props = {
  top_bar: "title_bar",
}

export default withBottombar(DomesticHelpParent, props);
